
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "ru",
  "es"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => import("../locales/en.json" /* webpackChunkName: "locale__home_namikko_Workspace_SwitchCase_rwa_estate_frontend_client_locales_en_json" */), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => import("../locales/de.json" /* webpackChunkName: "locale__home_namikko_Workspace_SwitchCase_rwa_estate_frontend_client_locales_de_json" */), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => import("../locales/ru.json" /* webpackChunkName: "locale__home_namikko_Workspace_SwitchCase_rwa_estate_frontend_client_locales_ru_json" */), cache: true }],
  "es": [{ key: "../locales/es.json", load: () => import("../locales/es.json" /* webpackChunkName: "locale__home_namikko_Workspace_SwitchCase_rwa_estate_frontend_client_locales_es_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "name": "English",
      "files": [
        "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/en.json"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "name": "Deutsch",
      "files": [
        "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/de.json"
      ]
    },
    {
      "code": "ru",
      "language": "ru-RU",
      "name": "Russian",
      "files": [
        "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/ru.json"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "name": "Spanish",
      "files": [
        "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/es.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "locales/",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "en",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "fallbackLocale": {
    "default": [
      "en",
      "en-legal"
    ]
  },
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "name": "English",
    "files": [
      {
        "path": "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/en.json"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "name": "Deutsch",
    "files": [
      {
        "path": "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/de.json"
      }
    ]
  },
  {
    "code": "ru",
    "language": "ru-RU",
    "name": "Russian",
    "files": [
      {
        "path": "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/ru.json"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "name": "Spanish",
    "files": [
      {
        "path": "/home/namikko/Workspace/SwitchCase/rwa-estate/frontend-client/locales/es.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
